import { http, HttpResponse } from 'msw';

import { organizationFixtures } from '../../fixtures/organization.fixtures';

const handlers = [
  http.get('/api/v1/organizations', () => {
    return HttpResponse.json(organizationFixtures.listResponse);
  }),
  http.get(
    '/api/cluster-management/v1/organizations/:orgId/components:view',
    () => {
      return HttpResponse.json({});
    }
  ),
];

export default handlers;
